import { POLYGON_CHAIN_ID_NUMBER, THETA_CHAIN_ID_NUMBER } from '../../constants';
import { getPreferredWalletProviderName } from './session';
import { WalletProvider, EipError } from '../types';
import { getConnector, getCurrentConnector } from '@wolffun/shared/src/utils/walletClient';
import ethersProvider from './ethersProvider';
export const getGasPrice = async () => {
  return ethersProvider.getGasPrice().then(gas => gas.toString()).catch(() => undefined);
};
export const getPreferredProvider = (ethereum, preferred) => {
  // ethereum.providers only exists when browser has more than 1 provider installed
  if (!(ethereum !== null && ethereum !== void 0 && ethereum.providers) || !Array.isArray(ethereum.providers)) return ethereum;

  if (!preferred) {
    const providerName = getPreferredWalletProviderName();

    if (!providerName) {
      return ethereum.providers[0];
    }

    preferred = providerName;
  }

  switch (preferred) {
    case WalletProvider.METAMASK:
      return tryGetMetamaskProvider(ethereum) || ethereum.providers[0];

    case WalletProvider.COINBASE:
      return tryGetCoinbaseProvider(ethereum) || ethereum.providers[0];

    default:
      return ethereum.providers[0];
    // just take the first provider as fallback
  }
};

const tryGetMetamaskProvider = (() => {
  let metamaskProvider;
  return ethereum => {
    var _ethereum$providers;

    if (!ethereum) return undefined;

    if (metamaskProvider) {
      return metamaskProvider;
    }

    if (!ethereum.providers && ethereum.isMetaMask) {
      metamaskProvider = ethereum;
      return ethereum;
    }

    const result = (_ethereum$providers = ethereum.providers) === null || _ethereum$providers === void 0 ? void 0 : _ethereum$providers.find(provider => provider.isMetaMask);
    metamaskProvider = result;
    return result;
  };
})();

const tryGetCoinbaseProvider = (() => {
  let coinbaseProvider;
  return ethereum => {
    var _ethereum$providers2;

    if (!ethereum) return undefined;

    if (coinbaseProvider) {
      return coinbaseProvider;
    }

    if (!ethereum.providers && ethereum.isCoinbaseWallet) {
      coinbaseProvider = ethereum;
      return ethereum;
    }

    const result = (_ethereum$providers2 = ethereum.providers) === null || _ethereum$providers2 === void 0 ? void 0 : _ethereum$providers2.find(provider => provider.isCoinbaseWallet);
    coinbaseProvider = result;
    return result;
  };
})();

export const checkWalletInstalled = preferred => {
  if (!preferred) {
    return undefined;
  }

  switch (preferred) {
    case WalletProvider.METAMASK:
      if (!getConnector(WalletProvider.METAMASK).ready) {
        return EipError.METAMASK_NOT_SUPPORTED;
      }

      return undefined;

    case WalletProvider.COINBASE:
      if (!getConnector(WalletProvider.COINBASE).ready) {
        return EipError.COINBASE_NOT_SUPPORT;
      }

      return undefined;

    case WalletProvider.WALLET_CONNECT: // Wallet connect does not require install extension

    case WalletProvider.SEQUENCE:
      //  Sequence does not require install extension
      return undefined;

    case WalletProvider.THETAN_WALLET:
      if (!getConnector(WalletProvider.THETAN_WALLET).ready) {
        return EipError.THETAN_WALLET_NOT_SUPPORT;
      }

      return undefined;

    default:
      return EipError.NO_PROVIDER_EXIST;
  }
};
export const ensureCorrectChain = async () => {
  try {
    const chainId = await getCurrentConnector().getChainId();

    if (chainId !== THETA_CHAIN_ID_NUMBER) {
      return {
        error: EipError.METAMASK_WRONG_CHAIN
      };
    }

    return undefined;
  } catch (err) {
    return {
      error: err.code
    };
  }
};
export const personalSignPolygon = async ({
  address,
  data
}) => {
  try {
    const connector = getCurrentConnector();
    await connector.switchChain(POLYGON_CHAIN_ID_NUMBER);
    const signature = await connector.signMessage({
      address: address,
      message: data
    });
    await connector.switchChain(THETA_CHAIN_ID_NUMBER);
    return {
      error: EipError.NO_ERROR,
      signature
    };
  } catch (err) {
    return {
      error: err.code
    };
  }
};